import { AGENCY_VIEW, APP_VIEW, ORG_VIEW } from '../../common/support/viewConstants';
import {
  AGENCY_DATA_FILTERS,
  AGGREGATE_DATA,
  APP_LEVEL_SETTINGS,
  CHANNEL_LEVEL_SETTINGS,
  EXPORT_ACCESS,
  FRAUD_REPORTING,
  FRAUD_MANAGER,
  LINK_LEVEL_SETTINGS,
  READ_PERMISSION,
  SENSITIVE_DATA,
  TEAM_ACCESS,
  WRITE_PERMISSION,
  MOBILE_SEARCH,
  LINK_TEMPLATE_SETTINGS,
} from '../../common/support/accessControlConstants';
import type { AccessResource } from '../types/accessControlTypes';
import type { PermissionLevel } from '../../../../shared/types/accessControl/permissionLevel.types';
export const isOrgView = () => {
  const { current_view } = window.App.context.view;
  return current_view === ORG_VIEW;
};
export const isAppView = () => {
  const { current_view } = window.App.context.view;
  return current_view === APP_VIEW;
};
export const isAgencyView = () => {
  const { current_view } = window.App.context.view;
  return current_view === AGENCY_VIEW;
};
export const isActiveFlipper = (beta: string) => {
  try {
    return Boolean(window.App.context.flipper[beta]);
  } catch (e) {
    console.debug('flipper not defined');
  }

  return false;
};
export const additionalViews = (view?: string[]) => {
  return {
    screenAvailableForOrg: Boolean(view && view.includes(ORG_VIEW)),
    screenAvailableForAgency: Boolean(view && view.includes(AGENCY_VIEW)),
  };
};
export const isRouteRestricted = (agencyView?: boolean, location?: any) => {
  const SCREENS_RESTRICTED_FROM_AGENCY_USERS = [
    '/account-settings/billing',
    '/account-settings/agencies',
    '/account-settings/sso',
  ];
  return (
    agencyView && SCREENS_RESTRICTED_FROM_AGENCY_USERS.some((forbiddenRoute) => location.pathname.startsWith(forbiddenRoute))
  );
};
export const READ_PERMISSIONS: Record<string, { accessResources: AccessResource[]; permission: PermissionLevel }> = {
  CHANNEL_LEVEL_SETTINGS: {
    permission: READ_PERMISSION,
    accessResources: [CHANNEL_LEVEL_SETTINGS],
  },
  CHANNEL_LEVEL_SETTINGS_AND_SENSITIVE_DATA: {
    permission: READ_PERMISSION,
    accessResources: [CHANNEL_LEVEL_SETTINGS, SENSITIVE_DATA],
  },
  CHANNEL_LEVEL_SETTINGS_AND_LINK_LEVEL_SETTINGS: {
    accessResources: [CHANNEL_LEVEL_SETTINGS, LINK_LEVEL_SETTINGS],
    permission: READ_PERMISSION,
  },
  CHANNEL_LEVEL_SETTINGS_AND_AGGREGATE_DATA_SETTINGS: {
    accessResources: [CHANNEL_LEVEL_SETTINGS, AGGREGATE_DATA],
    permission: READ_PERMISSION,
  },
  SENSITIVE_DATA: {
    permission: READ_PERMISSION,
    accessResources: [SENSITIVE_DATA],
  },
  LINK_LEVEL_SETTINGS: {
    accessResources: [LINK_LEVEL_SETTINGS],
    permission: READ_PERMISSION,
  },
  LINK_LEVEL_SETTINGS_AND_APP_LEVEL_SETTINGS: {
    accessResources: [LINK_LEVEL_SETTINGS, APP_LEVEL_SETTINGS],
    permission: READ_PERMISSION,
  },
  LINK_LEVEL_SETTINGS_AND_AGGREGATE_DATA: {
    accessResources: [LINK_LEVEL_SETTINGS, AGGREGATE_DATA],
    permission: READ_PERMISSION,
  },
  APP_LEVEL_SETTINGS: {
    accessResources: [APP_LEVEL_SETTINGS],
    permission: READ_PERMISSION,
  },
  TEAM_ACCESS: {
    accessResources: [TEAM_ACCESS],
    permission: READ_PERMISSION,
  },
  AGGREGATE_DATA: {
    permission: READ_PERMISSION,
    accessResources: [AGGREGATE_DATA],
  },
  SENSITIVE_DATA_AND_EXPORT_ACCESS: {
    permission: READ_PERMISSION,
    accessResources: [SENSITIVE_DATA, EXPORT_ACCESS],
  },
  AGGREGATE_DATA_AND_SENSITIVE_DATA: {
    permission: READ_PERMISSION,
    accessResources: [AGGREGATE_DATA, SENSITIVE_DATA],
  },
  AGGREGATE_DATA_AND_MOBILE_SEARCH: {
    permission: READ_PERMISSION,
    accessResources: [AGGREGATE_DATA, MOBILE_SEARCH],
  },
  APP_LEVEL_SETTINGS_AND_SENSITIVE_DATA: {
    permission: READ_PERMISSION,
    accessResources: [APP_LEVEL_SETTINGS, SENSITIVE_DATA],
  },
  FRAUD_REPORTING_AND_AGGREGATE_DATA: {
    accessResources: [FRAUD_REPORTING, AGGREGATE_DATA],
    permission: READ_PERMISSION,
  },
  FRAUD_MANAGER: {
    accessResources: [FRAUD_MANAGER],
    permission: READ_PERMISSION,
  },
  APP_LEVEL_SETTINGS_AND_SENSITIVE_DATA_WITH_NO_DATA_FILTERS: {
    permission: READ_PERMISSION,
    accessResources: [APP_LEVEL_SETTINGS, SENSITIVE_DATA, ...AGENCY_DATA_FILTERS],
  },
  LINK_TEMPLATE_SETTINGS: {
    permission: READ_PERMISSION,
    accessResources: [LINK_TEMPLATE_SETTINGS],
  },
};
export const WRITE_PERMISSIONS: Record<string, { accessResources: AccessResource[]; permission: PermissionLevel }> = {
  TEAM_ACCESS: {
    permission: WRITE_PERMISSION,
    accessResources: [TEAM_ACCESS],
  },
  APP_LEVEL_SETTINGS_AND_SENSITIVE_DATA: {
    permission: WRITE_PERMISSION,
    accessResources: [APP_LEVEL_SETTINGS, SENSITIVE_DATA],
  },
  APP_LEVEL_SETTINGS: {
    permission: WRITE_PERMISSION,
    accessResources: [APP_LEVEL_SETTINGS],
  },
  MOBILE_SEARCH: {
    permission: WRITE_PERMISSION,
    accessResources: [MOBILE_SEARCH],
  },
  LINK_LEVEL_SETTINGS: {
    accessResources: [LINK_LEVEL_SETTINGS],
    permission: WRITE_PERMISSION,
  },
};
